module.exports = __webpack_public_path__ + "img/hc_selectLanguage.ec6ec5f4.png";